import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash'

import { registerFinalUser, removeUser, sendPdfMultipleFileStorage } from '../../dao-firebase/daofirebase'

import {
  Table,
  Button,
  Row,
  Grid,
  Col,
  Image,
  Panel,
  ButtonGroup,
  FormControl,
  FormGroup,
  Jumbotron,
  Label,
  Alert,
  Tabs,
  Tab,
  Modal,
  Glyphicon,
} from 'react-bootstrap';

import If from "../../utils/If"

import Loader from 'react-loader-advanced';

import placeholderUser from '../../statics/images/placeholder_user.jpg'

import '../../statics/css/user-detail.css'
import '../../statics/css/util.css'

import editImg from '../../statics/images/edit.svg'
import Anamnese from './user-anamnese';
import ListPdfsAvaliations from './avaliation-list';
import TableTrainings from '../treinos/table-trainings';
import MountTraining from '../treinos/mount-training';

import {
  saveTrainingToUser,
  saveAnamneseToUser,
  updateUser, deleteRequisitionUser,
  updateUserAttr, inactiveUser, createUser,
  activeUser
} from '../../dao-firebase/user-firebase'
import { getUrlProfilePic } from '../../dao-firebase/daofirebase'
import { fetchTrainingById } from '../../dao-firebase/training-daofirebae'
import { formatJsDateToPt, stringDateToJsDate, difDates } from '../../utils/functions';

class AlunoDetail extends Component {

  constructor(props) {
    super(props);

    this.state = {
      load: false,
      aluno: this.props.location.alunoSelected,
      createUserMessage: '',
      showModalSelectTraining: false,

      //search
      search_table_all_trainings: '',

      //Modal
      search_table_all_trainings: '',

      select_training_detailed: undefined,
      selected_training_modal: undefined,

      loadSelectTrainingModal: false,
      messageAll: '',
      messageAllStatus: 'warning',

      //tab training
      training_to_look: undefined,
      load_training_tab: true,

      updateComponenent: false,
      updateComponenentAnamnese: false,

      showModalWeight: false,
      showModalHeight: false,

      form_weight: undefined,
      form_height: undefined,

      loadModalWeight: false,
      loadModalHeight: false,

      form_time_training: "",
      loadModalTimeTraining: false,
      feedback_time_training: undefined,

      form_contract_date: "",
      loadModalContractDate: false,
      feedback_contract_date: undefined,

      loadModalService: false,

      //pdfs
      showModalPdfsAvaliations: false,
      loadPdfsAvaliations: false,
      title_type_avaliations: "",
      type_avaliation: 0,

      showDialogConfirmDeleteUser: false,

      urlProfilePick: "",

    };

    this.handleFileUpload1 = this.handleFileUpload1.bind(this)
    this.handleFileUpload2 = this.handleFileUpload2.bind(this)
    this.handleFileUpload3 = this.handleFileUpload3.bind(this)
    this.handleFileUpload4 = this.handleFileUpload4.bind(this)
    this.handleFileUpload5 = this.handleFileUpload5.bind(this)

  }

  componentDidMount() {

    if (this.props.location.alunoSelected) {
      console.log(this.props.location.alunoSelected)
    }

  }

  componentWillMount() {
    if (this.props.location.alunoSelected) {

      //corrigindo para casos em que ainda não exista as infos body
      if (!this.props.location.alunoSelected.data.infos_body) {
        this.props.location.alunoSelected.data.infos_body = {};
      } else {
        this.setState({
          form_weight: this.props.location.alunoSelected.data.infos_body.weight,
          form_height: this.props.location.alunoSelected.data.infos_body.height,
        })

      }

      //Incluindo foto 
      console.log("TO FOTO: ", this.props.location.alunoSelected)
      getUrlProfilePic(this.props.location.alunoSelected.id, (url) => {
        this.setState({
          urlProfilePick: url
        })
      });

      this.setState({
        aluno: this.props.location.alunoSelected,
        form_service: this.props.location.alunoSelected.data.service,
      }, () => {

        //carregando treino do user caso ele possua
        console.log("TRAINING USER: " + this.state.aluno.data.training);
        console.log("SERVICE: " + this.state.form_service)
        if (this.state.aluno
          && this.state.aluno.data
          && this.state.aluno.data.training
          && this.state.aluno.data.training != '') {

          fetchTrainingById(JSON.parse(localStorage.getItem("USER")).uid, this.state.aluno.data.training.id, (response, success) => {

            if (success) {
              //Na resposta success o "response" é o doc training
              console.log("TRAINING RESPONSE")
              console.log(response)

              if (response != undefined && response != "" && response.data) {
                //adicionando data de ultima atualizacao do treino
                console.log("Entrou no response AOEH")
                response.date_update_training = this.state.aluno.data.training.date_update_training;

                console.log("DATE UPDATE TRAINING: " + this.state.aluno.data.training.date_update_training);
                console.log("TTRAINING_TIME: " + this.state.aluno.data.training.training_time);
                response.training_time = this.state.aluno.data.training.training_time;

                this.setState({
                  training_to_look: response,
                  load_training_tab: false,
                })

              } else {
                console.log("Entrou embaixo")
                this.state.aluno.data.training = undefined;
                this.setState({
                  aluno: this.state.aluno,
                  load_training_tab: false,
                })
              }


            } else {
              this.setState({
                messageTabTraining: response.message,
                load_training_tab: false,
              })
            }
          })
        }
      })

      console.log("ALUNO DETAIL: " + this.props.location.alunoSelected.data.name)
    } else {
      this.props.history.push('/')
    }
    //console.log(this.props.location.alunoSelected.name)
  }

  getAge(dateString) {
    let splittedDate = dateString.split('/')
    let birthday = +new Date(splittedDate[2], splittedDate[1], splittedDate[0], 0, 0, 0, 0);
    return ~~((Date.now() - birthday) / (31557600000));
  }

  getGenderName(gender) {
    if (gender == 'male') {
      return 'Masculino'
    } else if (gender == "female") {
      return "Feminino"
    } else {
      return "Outro"
    }
  }

  uploadFile(type) {

    let node = '';
    let title = '';
    console.log("TYPE: " + type)
    this.setState({
      type_avaliation: "type_" + type,
    })
    switch (type) {
      case 1:
        // node = ReactDOM.findDOMNode(this.refs.inputNode1);
        // if (node && node.focus instanceof Function) {
        //   node.click();
        // }
        title = "ALONGAMENTOS";
        break;
      case 2:
        // node = ReactDOM.findDOMNode(this.refs.inputNode2);
        // if (node && node.focus instanceof Function) {
        //   node.click();
        // }
        title = "AVALIAÇÕES FÍSICAS";
        break;
      case 3:
        // node = ReactDOM.findDOMNode(this.refs.inputNode3);
        // if (node && node.focus instanceof Function) {
        //   node.click();
        // }
        title = "EBOOK";
        break;
      case 4:
        // node = ReactDOM.findDOMNode(this.refs.inputNode4);
        // if (node && node.focus instanceof Function) {
        //   node.click();
        // }
        title = "LEGENDAS";
        break;
      case 5:
        // node = ReactDOM.findDOMNode(this.refs.inputNode4);
        // if (node && node.focus instanceof Function) {
        //   node.click();
        // }
        title = "PLANO ALIMENTAR";
        break;
    }

    console.log("EVALUATIONS: ", this.state.aluno.data.evaluations)

    this.setState({
      showModalPdfsAvaliations: true,
      title_type_avaliations: title,
    })



  }

  renderMessage(message) {
    return (
      <p>
        <strong>{message.substring(0, message.indexOf(" "))}</strong>
        {message.substring(message.indexOf(" "))}
      </p>
    )
  }

  // Component method
  handleFileUpload1(event) {

    this.setState({
      loadPdfsAvaliations: true,
    })

    console.log("TYPE_1")
    const file = event.target.files[0]
    if (this.state.aluno) {

      let nameSeconds = new Date().getTime();
      sendPdfMultipleFileStorage(this.state.aluno.id, "TYPE_1", file, nameSeconds, (response, success) => {

        if (success) {
          this.addRefPdfToUser(1, response, nameSeconds);
        }

      })
    }
  }
  // Component method
  handleFileUpload2(event) {

    this.setState({
      loadPdfsAvaliations: true,
    })
    console.log("TYPE_2")
    const file = event.target.files[0]
    if (this.state.aluno) {

      let nameSeconds = new Date().getTime();
      sendPdfMultipleFileStorage(this.state.aluno.id, "TYPE_2", file, nameSeconds, (response, success) => {
        if (success) {
          this.addRefPdfToUser(2, response, nameSeconds);
        }
      })
    }
  }
  // Component method
  handleFileUpload3(event) {

    this.setState({
      loadPdfsAvaliations: true,
    })
    console.log("TYPE_3")
    const file = event.target.files[0]
    if (this.state.aluno) {

      let nameSeconds = new Date().getTime();
      sendPdfMultipleFileStorage(this.state.aluno.id, "TYPE_3", file, nameSeconds, (response, success) => {
        if (success) {
          this.addRefPdfToUser(3, response, nameSeconds);
        }
      })
    }
  }
  // Component method
  handleFileUpload4(event) {

    this.setState({
      loadPdfsAvaliations: true,
    })
    console.log("TYPE_4")
    const file = event.target.files[0]
    if (this.state.aluno) {

      let nameSeconds = new Date().getTime();
      sendPdfMultipleFileStorage(this.state.aluno.id, "TYPE_4", file, nameSeconds, (response, success) => {
        if (success) {
          this.addRefPdfToUser(4, response, nameSeconds);
        }
      })
    }
  }

  // Component method
  handleFileUpload5(event) {

    this.setState({
      loadPdfsAvaliations: true,
    })
    console.log("TYPE_5")
    const file = event.target.files[0]
    if (this.state.aluno) {

      let nameSeconds = new Date().getTime();
      sendPdfMultipleFileStorage(this.state.aluno.id, "TYPE_5", file, nameSeconds, (response, success) => {
        if (success) {
          this.addRefPdfToUser(5, response, nameSeconds);
        }
      })
    }
  }

  //Response corresponde a url do pdf
  addRefPdfToUser(type, response, nameSeconds) {

    let objEvaluation = {
      dateInMillis: nameSeconds,
      linkPdf: response,
    }

    if (!this.state.aluno.data.evaluations) {

      this.state.aluno.data['evaluations'] = {};
      this.state.aluno.data['evaluations']['type_1'] = [];
      this.state.aluno.data['evaluations']['type_2'] = [];
      this.state.aluno.data['evaluations']['type_3'] = [];
      this.state.aluno.data['evaluations']['type_4'] = [];
      this.state.aluno.data['evaluations']['type_5'] = [];
      this.state.aluno.data['evaluations']['type_' + type].push(objEvaluation);

    } else {

      if (!this.state.aluno.data['evaluations']['type_' + type]) {
        this.state.aluno.data['evaluations']['type_' + type] = [];
      }

      this.state.aluno.data['evaluations']['type_' + type].push(objEvaluation);
    }

    console.log(this.state.aluno)
    //Updating de atualização as evaluations
    updateUser(JSON.parse(localStorage.getItem("USER")).uid, this.state.aluno, (response, success) => {

      if (success) {

        this.setState({
          messageAll: "Arquivo enviado com sucesso!",
          messageAllStatus: "success",
          loadPdfsAvaliations: false,
          showModalPdfsAvaliations: false,
        })

        setTimeout(() => {

          if (this.state.messageAll == "Arquivo enviado com sucesso!") {
            this.setState({
              messageAll: '',
            });
          }
        }, 5000);

        window.scrollTo(0, 0);

      } else {

        this.setState({
          messageAll: "Falha ao enviar arquivo!",
          messageAllStatus: "warning",
          loadPdfsAvaliations: false,
          showModalPdfsAvaliations: false,
        })

        setTimeout(() => {

          if (this.state.messageAll == "Falha ao enviar arquivo!") {
            this.setState({
              messageAll: '',
            });
          }
        }, 5000);

        window.scrollTo(0, 0);

      }
    })
  }

  saveUser() {

    this.setState({
      load: true,
    })

    //Inicialmente a senha será a data de nascimento sem as barras
    createUser(JSON.parse(localStorage.getItem("USER")).uid, this.state.aluno.data.email.toString().trim(),
      this.state.aluno.data.born_date.replace(/\//g, "").toString().trim(), (userOrMessage, success) => {

        console.log("Resposta create user: " + JSON.stringify(userOrMessage))

        if (success) {

          this.state.aluno.data.status = "ACTIVE";
          registerFinalUser(JSON.parse(localStorage.getItem("USER")).uid, userOrMessage.user.uid, this.state.aluno.data, (response, success) => {
            console.log("Menssagem: " + response);
            if (success) {

              removeUser(JSON.parse(localStorage.getItem("USER")).uid, this.state.aluno.id, userOrMessage.user.uid, (success) => {

                //Substituindo o antigo id pelo novo, agora na collection de users
                //Isso mantem a consistencia do aluno selecionado na tela
                this.state.aluno.id = userOrMessage.user.uid;

                if (success) {
                  this.setState({
                    aluno: this.state.aluno,
                    messageAll: "Usuário registrado com sucesso!",
                    messageAllStatus: "success",
                    load: false,
                  })

                  setTimeout(() => {

                    if (this.state.messageAll == "Usuário registrado com sucesso!") {
                      this.setState({
                        messageAll: '',
                      });
                    }
                  }, 5000);

                } else {
                  this.setState({
                    aluno: this.state.aluno,
                    messageAll: "Erro ao registrar usuário",
                    messageAllStatus: "warning",
                    load: false,
                  })
                }
              })
            } else {
              this.setState({
                messageAll: response,
                messageAllStatus: "warning",
                load: false,
              })
            }
          })


        } else {
          this.setState({
            createUserMessage: userOrMessage,
            load: false,
          })
        }

      })

  }

  onInputWeightChange(target) {

    let value = target.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/,/g, "");

    console.log("VALUE: " + value)

    while (value.startsWith("0")) {
      value = value.substring(1);
    }

    if (value.length == 1) {

      value = "00," + value;
    } else if (value.length == 2) {

      value = "0" + value.substring(0, 1) + "," + value.substring(1);
    } else if (value.length == 3) {

      value = value.substring(0, 2) + "," + value.substring(2, 3);
    } else if (value.length >= 4) {

      value = value.substring(0, 3) + "," + value.substring(3, 4);
    }

    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  onInputHeightChange(target) {

    let value = target.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/,/g, "");

    console.log("VALUE: " + value)

    while (value.startsWith("0")) {
      value = value.substring(1);
    }

    if (value.length == 1) {

      value = "0,0" + value;
    } else if (value.length == 2) {

      value = "0," + value.substring(0, 1) + value.substring(1);
    } else if (value.length >= 3) {

      value = value.substring(0, 1) + "," + value.substring(1, 3);
    }

    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  onInputChange(target) {

    console.log(target);

    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  openModalChangeService() {

    this.setState({
      showDialogChangeService: true,
    })

  }

  handleCloseChangeService() {
    this.setState({
      showDialogChangeService: false,
    })
  }


  openModalSelectTraining() {

    this.setState({
      //Modal
      search_table_all_trainings: '',

      select_training_detailed: undefined,
      selected_training_modal: undefined,
      showModalSelectTraining: true,
    })
  }

  handleCloseTrainingsModal() {
    this.setState({
      showModalSelectTraining: false,
    })
  }

  //Handler do training da seleção de treinos do modal
  handleDetailTraining(training) {

    this.setState({
      select_training_detailed: training,
    })

  }

  backDetailTrainingModal() {
    this.setState({
      select_training_detailed: undefined,
    })
  }

  handleSelectTrainingModal(training) {
    this.setState({
      selected_training_modal: training,
    })
  }

  handleOpenWeightModal() {

    this.setState({
      showModalWeight: true,
    })
  }

  handleCloseWeightModal() {

    this.setState({
      showModalWeight: false,
    })
  }

  handleOpenHeightModal() {

    this.setState({
      showModalHeight: true,
    })
  }

  handleCloseHeightModal() {

    this.setState({
      showModalHeight: false,
    })
  }

  handleOpenTimeTrainingModal() {

    //Adicionando form_vencimento do treino
    //Caso não tenha sido setado ele deve ser substituído por string vazia
    let timeTrainingToForm = this.state.training_to_look.training_time;
    if (timeTrainingToForm == undefined) {
      timeTrainingToForm = "";
    } else {
      timeTrainingToForm = formatJsDateToPt(timeTrainingToForm);
    }

    this.setState({
      showModalTimeTraining: true,
      form_time_training: timeTrainingToForm,
    })
  }

  handleCloseTimeTrainingModal() {
    this.setState({
      showModalTimeTraining: false,
    })
  }

  handleOpenContractDateModal() {

    //Adicionando form_vencimento do treino
    //Caso não tenha sido setado ele deve ser substituído por string vazia
    let contractDateToForm = this.state.aluno.data.contract_date;
    if (contractDateToForm == undefined) {
      contractDateToForm = "";
    } else {
      contractDateToForm = formatJsDateToPt(contractDateToForm);
    }

    this.setState({
      showModalContractDate: true,
      form_contract_date: contractDateToForm,
    })
  }

  handleCloseContractDateModal() {
    this.setState({
      showModalContractDate: false,
    })
  }

  updateTimeTraining() {

    this.setState({

      loadModalTimeTraining: true,

    })


    let newTimeTraining = stringDateToJsDate(this.state.form_time_training);
    console.log(newTimeTraining);
    updateUserAttr(JSON.parse(localStorage.getItem("USER")).uid, this.state.aluno, "training.training_time", newTimeTraining, (response, success) => {

      if (success) {

        //simulando objeto timestamp
        this.state.training_to_look.training_time = {
          seconds: newTimeTraining.getTime() / 1000,
        };

        this.setState({

          loadModalTimeTraining: false,
          messageAll: "Vencimento do treino alterado com sucesso!",
          messageAllStatus: "success",
          showModalTimeTraining: false,
          training_to_look: this.state.training_to_look,
          updateComponenent: !this.state.updateComponenent,
        })

        setTimeout(() => {

          if (this.state.messageAll == "Vencimento do treino alterado com sucesso!") {
            this.setState({
              messageAll: '',
            });
          }
        }, 5000);

        window.scrollTo(0, 0);

      } else {
        this.setState({

          loadModalTimeTraining: false,
          messageAll: "Erro ao alterar vencimento: " + response.message,
          messageAllStatus: "error",
          showModalTimeTraining: false,
        })

        setTimeout(() => {

          if (this.state.messageAll == "Erro ao alterar vencimento: " + response.message) {
            this.setState({
              messageAll: '',
            });
          }
        }, 5000);

        window.scrollTo(0, 0);
      }
    })

  }

  updateContractDate() {

    this.setState({

      loadModalContractDate: true,

    })


    let newContractDate = stringDateToJsDate(this.state.form_contract_date);
    console.log(newContractDate);
    let uidProfessor = JSON.parse(localStorage.getItem("USER")).uid;
    updateUserAttr(uidProfessor, this.state.aluno, "contract_date", newContractDate, (response, success) => {

      if (success) {

        activeUser(uidProfessor, this.state.aluno.id, (response, success) => {

          //simulando objeto timestamp
          this.state.aluno.data.contract_date = {
            seconds: newContractDate.getTime() / 1000,
          };

          this.setState({

            loadModalContractDate: false,
            messageAll: "Vencimento do contrato alterado com sucesso!",
            messageAllStatus: "success",
            showModalContractDate: false,
          })

          setTimeout(() => {

            if (this.state.messageAll == "Vencimento do contrato alterado com sucesso!") {
              this.setState({
                messageAll: '',
              });
            }
          }, 5000);

          window.scrollTo(0, 0);

        })



      } else {
        this.setState({

          loadModalContractDate: false,
          messageAll: "Erro ao alterar vencimento: " + response.message,
          messageAllStatus: "error",
          showModalContractDate: false,
        })

        setTimeout(() => {

          if (this.state.messageAll == "Erro ao alterar vencimento: " + response.message) {
            this.setState({
              messageAll: '',
            });
          }
        }, 5000);

        window.scrollTo(0, 0);
      }
    })

  }

  updateService() {

    this.setState({

      loadModalService: true,

    })


    updateUserAttr(JSON.parse(localStorage.getItem("USER")).uid, this.state.aluno, "service", this.state.form_service, (response, success) => {

      if (success) {

        //simulando objeto timestamp
        this.state.aluno.data.service = this.state.form_service;

        this.setState({
          loadModalService: false,
          messageAll: "Serviço alterado com sucesso!",
          messageAllStatus: "success",
          showDialogChangeService: false,
        })

        setTimeout(() => {

          if (this.state.messageAll == "Serviço alterado com sucesso!") {
            this.setState({
              messageAll: '',
            });
          }
        }, 5000);

        window.scrollTo(0, 0);

      } else {
        this.setState({

          loadModalService: false,
          messageAll: "Erro ao alterar serviço: " + response.message,
          messageAllStatus: "error",
          showDialogChangeService: false,
        })

        setTimeout(() => {

          if (this.state.messageAll == "Erro ao alterar serviço: " + response.message) {
            this.setState({
              messageAll: '',
            });
          }
        }, 5000);

        window.scrollTo(0, 0);
      }
    })

  }

  selectTrainingToUser() {

    this.setState({
      loadSelectTrainingModal: true,
    })

    //salvando o id do treino no objeto user
    saveTrainingToUser(JSON.parse(localStorage.getItem("USER")).uid, this.state.selected_training_modal, this.state.aluno, (response, success) => {

      console.log("RESPONSE VINCULACAO DE TREINO");
      console.log(response);

      if (success) {

        //adicionando data de ultima atualizacao do treino
        this.state.selected_training_modal.date_update_training = {
          seconds: new Date().getTime() / 1000,
        };

        //adicionando validade do treino, inicialmente 30 dias
        this.state.selected_training_modal.training_time = response.training_time;

        this.setState({
          messageAll: "Treino adicionado com sucesso!",
          messageAllStatus: "success",
          showModalSelectTraining: false,
          loadSelectTrainingModal: false,
          training_to_look: this.state.selected_training_modal,
          selected_training_modal: undefined,
          updateComponenent: !this.state.updateComponenent,
        })

        setTimeout(() => {
          this.setState({
            messageAll: '',
          });
        }, 5000);
      } else {
        this.setState({
          messageAll: "Falha ao adicionar o treino: " + response.message,
          messageAllStatus: "danger",
          showModalSelectTraining: false,
          loadSelectTrainingModal: false,
        })
      }

    })


  }

  handleSaveAnamnese(anamnese) {

    this.setState({
      load: true,
    })

    saveAnamneseToUser(JSON.parse(localStorage.getItem("USER")).uid, this.state.aluno, anamnese, (response, success) => {

      if (success) {

        this.setState({

          messageAll: "Anamnese atualizada com sucesso!",
          messageAllStatus: "success",
          updateComponenentAnamnese: !this.state.updateComponenentAnamnese,
          load: false,
        })


        //Trazendo scroll pra 0 pra garantir a visibilidade da mensagem
        window.scrollTo(0, 0);

        setTimeout(() => {
          if (this.state.messageAll == "Anamnese atualizada com sucesso!") {

            this.setState({
              messageAll: '',
            });

          }
        }, 5000);

      } else {
        this.setState({

          messageAll: "Falha ao atualizar Anamnese!",
          messageAllStatus: "danger",
          load: false,
        })
      }
    })
  }

  selectPdfToUpload(type) {

    let node = '';
    type = type.substring(5);
    console.log("TYPE: " + type);
    switch (type) {
      case "1":
        node = ReactDOM.findDOMNode(this.refs.inputNode1);
        if (node && node.focus instanceof Function) {
          node.click();
        }

        break;
      case "2":
        node = ReactDOM.findDOMNode(this.refs.inputNode2);
        if (node && node.focus instanceof Function) {
          node.click();
        }

        break;
      case "3":
        node = ReactDOM.findDOMNode(this.refs.inputNode3);
        if (node && node.focus instanceof Function) {
          node.click();
        }

        break;
      case "4":
        node = ReactDOM.findDOMNode(this.refs.inputNode4);
        if (node && node.focus instanceof Function) {
          node.click();
        }

        break;
      case "5":
        node = ReactDOM.findDOMNode(this.refs.inputNode5);
        if (node && node.focus instanceof Function) {
          node.click();
        }

        break;
    }
  }


  renderMessage(message) {
    return (
      <p>
        <strong>{message.substring(0, message.indexOf(" "))}</strong>
        {message.substring(message.indexOf(" "))}
      </p>
    )
  }

  doActiveUser() {

    this.setState({

      load: true,
    })

    //Ativando usuário
    this.state.aluno.data.status = "ACTIVE";

    let uidProfessor = JSON.parse(localStorage.getItem("USER")).uid;
    activeUser(uidProfessor, this.state.aluno.id, (success) => {

      if (success) {
        updateUser(uidProfessor, this.state.aluno, (response, success) => {

          if (success) {

            //Aluno oi ativado com sucesso STATUS AGORA ESTÁ ACTIVE
            this.setState({

              load: false,
              messageAll: "Aluno ativado com sucesso!",
              messageAllStatus: "success",
            })

            setTimeout(() => {

              if (this.state.messageAll == "Aluno ativado com sucesso!") {
                this.setState({
                  messageAll: '',
                });
              }
            }, 5000);


          } else {
            this.setState({

              load: false,
              messageAll: "Falha ao ativar o aluno:" + response.message,
              messageAllStatus: "danger",
            })

            setTimeout(() => {

              if (this.state.messageAll == "Falha ao ativar o aluno:" + response.message) {
                this.setState({
                  messageAll: '',
                });
              }
            }, 5000);
          }
        })
      } else {
        this.setState({

          load: false,
          messageAll: "Falha ao ativar o aluno",
          messageAllStatus: "danger",
        })

        setTimeout(() => {

          if (this.state.messageAll == "Falha ao ativar o aluno") {
            this.setState({
              messageAll: '',
            });
          }
        }, 5000);
      }

    })

  }

  deleteUser() {
    this.setState({

      load: true,

    })

    //Ativando usuário
    this.state.aluno.data.status = "REMOVED";
    updateUser(JSON.parse(localStorage.getItem("USER")).uid, this.state.aluno, (response, success) => {

      if (success) {

        alert("Aluno removido com sucesso")

        this.props.history.push('/alunos')

      } else {
        this.setState({

          load: false,
          messageAll: "Falha ao remover o aluno:" + response.message,
          messageAllStatus: "danger",
        })

        setTimeout(() => {

          if (this.state.messageAll == "Falha ao remover o aluno:" + response.message) {
            this.setState({
              messageAll: '',
            });
          }
        }, 5000);
      }
    })
  }

  inactiveUser() {
    this.setState({

      load: true,
    })

    //Ativando usuário
    this.state.aluno.data.status = "INATIVE";

    let uidProfessor = JSON.parse(localStorage.getItem("USER")).uid;

    console.log("UID ALUNO: ", this.state.aluno);

    inactiveUser(uidProfessor, this.state.aluno.id, (response, success) => {

      if (success) {
        updateUser(uidProfessor, this.state.aluno, (response, success) => {

          if (success) {

            //Aluno oi ativado com sucesso STATUS AGORA ESTÁ ACTIVE
            this.setState({

              load: false,
              messageAll: "Aluno desativado com sucesso!",
              messageAllStatus: "success",
            })

            setTimeout(() => {

              if (this.state.messageAll == "Aluno desativado com sucesso!") {
                this.setState({
                  messageAll: '',
                });
              }
            }, 5000);


          } else {
            this.setState({

              load: false,
              messageAll: "Falha ao desativar o aluno:" + response.message,
              messageAllStatus: "danger",
            })

            setTimeout(() => {

              if (this.state.messageAll == "Falha ao desativar o aluno:" + response.message) {
                this.setState({
                  messageAll: '',
                });
              }
            }, 5000);
          }
        })
      } else {
        this.setState({

          load: false,
          messageAll: "Falha ao desativar o aluno:" + response.message,
          messageAllStatus: "danger",
        })

        setTimeout(() => {

          if (this.state.messageAll == "Falha ao desativar o aluno:" + response.message) {
            this.setState({
              messageAll: '',
            });
          }
        }, 5000);
      }
    })

  }

  saveWeight() {
    this.setState({

      loadModalWeight: true,
    })

    //Ativando usuário
    if (!this.state.aluno.data.infos_body) {
      this.state.aluno.data.infos_body = {};
    }

    this.state.aluno.data.infos_body.weight = this.state.form_weight;
    updateUser(JSON.parse(localStorage.getItem("USER")).uid, this.state.aluno, (response, success) => {

      if (success) {

        //Aluno oi ativado com sucesso STATUS AGORA ESTÁ ACTIVE
        this.setState({

          loadModalWeight: false,
          messageAll: "Peso atualizado com sucesso!",
          messageAllStatus: "success",
          showModalWeight: false,
        })

        setTimeout(() => {

          if (this.state.messageAll == "Peso atualizado com sucesso!") {
            this.setState({
              messageAll: '',
            });
          }
        }, 5000);


      } else {
        this.setState({

          loadModalWeight: false,
          messageAll: "Falha ao atualizar peso do aluno:" + response.message,
          messageAllStatus: "danger",
          showModalWeight: false,
        })

        setTimeout(() => {

          if (this.state.messageAll == "Falha ao atualizar peso do aluno:" + response.message) {
            this.setState({
              messageAll: '',
            });
          }
        }, 5000);
      }
    })

  }

  handleCloseModalPdfs() {
    this.setState({
      showModalPdfsAvaliations: false,
    })
  }

  saveHeight() {
    this.setState({

      loadModalHeight: true,
    })

    //Ativando usuário
    if (!this.state.aluno.data.infos_body) {
      this.state.aluno.data.infos_body = {};
    }
    this.state.aluno.data.infos_body.height = this.state.form_height;
    updateUser(JSON.parse(localStorage.getItem("USER")).uid, this.state.aluno, (response, success) => {

      if (success) {

        //Aluno oi ativado com sucesso STATUS AGORA ESTÁ ACTIVE
        this.setState({

          loadModalHeight: false,
          messageAll: "Altura atualizada com sucesso!",
          messageAllStatus: "success",
          showModalHeight: false,
        })

        setTimeout(() => {

          if (this.state.messageAll == "Altura atualizada com sucesso!") {
            this.setState({
              messageAll: '',
            });
          }
        }, 5000);


      } else {
        this.setState({

          loadModalHeight: false,
          messageAll: "Falha ao atualizar a altura do aluno:" + response.message,
          messageAllStatus: "danger",
          showModalHeight: false,
        })

        setTimeout(() => {

          if (this.state.messageAll == "Falha ao atualizar a altura do aluno:" + response.message) {
            this.setState({
              messageAll: '',
            });
          }
        }, 5000);
      }
    })

  }

  closeAndMessageEvaluationsModal(message) {

    this.handleCloseModalPdfs();
    this.setState({
      messageAll: message,
      messageAllStatus: "success",
      loadPdfsAvaliations: false,
      showModalPdfsAvaliations: false,
    })

    setTimeout(() => {

      if (this.state.messageAll == message) {
        this.setState({
          messageAll: '',
        });
      }
    }, 5000);

    window.scrollTo(0, 0);
  }

  getImc() {

    let w = this.state.aluno.data.infos_body.weight.replace(",", ".");
    let h = this.state.aluno.data.infos_body.height.replace(",", ".");
    console.log(w)
    console.log(h)
    console.log(parseFloat(w))
    console.log(parseFloat(h))

    let value = parseFloat(w) / (parseFloat(h) * parseFloat(h));

    return value.toFixed(2);
  }

  handleShowConfirmDeleteUser() {
    this.setState({
      showDialogConfirmDeleteUser: true,
    })
  }

  handleCloseConfirmDeleteUser() {
    this.setState({
      showDialogConfirmDeleteUser: false,
    })
  }

  //Deleção de usuário que ainda não foi aceito, deleta-se apeaas no firestore
  removeRequisitionUser() {

    this.setState({
      load: true,
    })

    console.log(this.state.aluno)

    deleteRequisitionUser(JSON.parse(localStorage.getItem("USER")).uid, this.state.aluno, (success) => {
      if (success) {

        alert("Requisição de usuário removida com sucesso!");
        this.props.history.push('/alunos')

      } else {
        this.setState({

          messageAll: "Falha ao deletar requisição de usuário!",
          messageAllStatus: "error",
          load: false,
        })

        setTimeout(() => {

          if (this.state.messageAll == "Falha ao deletar requisição de usuário!") {
            this.setState({
              messageAll: '',
            });
          }
        }, 5000);
      }
    });
  }

  onInputDateMaskChange(target) {

    let value = target.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/\//g, "");

    console.log(value + " - Length: " + value.length);

    if (value.length >= 3 && value.length < 5) {
      let aux = value;
      value = aux.substring(0, 2);
      value += "/";
      value += aux.substring(2);
    } else if (value.length >= 5) {
      let aux = value;
      value = aux.substring(0, 2);
      value += "/";
      value += aux.substring(2, 4);
      value += "/";
      value += aux.substring(4);
    } else if (value.length >= 8) {
      let aux = value;
      value = aux.substring(0, 2);
      value += "/";
      value += aux.substring(2, 4);
      value += "/";
      value += aux.substring(4, 8);
    }

    //console.log("VALUE: " + value);
    if (value.length > 10) {
      value = value.substring(0, 10);
    }

    console.log("IS VALID DATE: " + this.isValidDate(value))

    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  isValidDate(dateString) {
    // First check for the pattern
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString))
      return false;

    // Parse the date parts to integers
    var parts = dateString.split("/");
    var day = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10);
    var year = parseInt(parts[2], 10);

    // Check the ranges of month and year
    if (year < 1000 || year > 3000 || month == 0 || month > 12)
      return false;

    var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Adjust for leap years
    if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
      monthLength[1] = 29;

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
  };

  isAfterDate(date) {

    let today = new Date();
    today.setHours(0, 0, 0, 0);
    let splittedDate = date.split("/");
    let myDate = new Date(splittedDate[2], parseInt(splittedDate[1]) - 1, splittedDate[0], 0, 0, 0, 0);
    //console.log("Comparando: " + today + " - " + myDate);
    if (today.getTime() > myDate.getTime()) {
      return false;
    } else {
      return true;
    }

  }

  getValidationStateTimeTrainingDate() {
    const length = this.state.form_time_training.length;
    //console.log("this.state.born_date: " + this.state.form_born_date)
    if (length == 10 && !this.isAfterDate(this.state.form_time_training)) {

      return 'error/Data não pode ser do passado';
    }
    else if (this.isValidDate(this.state.form_time_training)) {
      //console.log("Entrou aqui")
      return 'success/';
    } else if (length == 10 && !this.isValidDate(this.state.form_time_training)) {

      return 'error/Data inválida';

    } else if (length > 0 && !this.isValidDate(this.state.form_time_training)) {
      return 'warning/';
    }
    // if (length > 10) return 'success';
    // else if (length > 5) return 'warning';
    // else if (length > 0) return 'error';
    return "";
  }

  getValidationStateContractDate() {
    const length = this.state.form_contract_date.length;
    //console.log("this.state.born_date: " + this.state.form_born_date)
    if (length == 10 && !this.isAfterDate(this.state.form_contract_date)) {

      return 'error/Data não pode ser do passado';
    }
    else if (this.isValidDate(this.state.form_contract_date)) {
      //console.log("Entrou aqui")
      return 'success/';
    } else if (length == 10 && !this.isValidDate(this.state.form_contract_date)) {

      return 'error/Data inválida';

    } else if (length > 0 && !this.isValidDate(this.state.form_contract_date)) {
      return 'warning/';
    }
    // if (length > 10) return 'success';
    // else if (length > 5) return 'warning';
    // else if (length > 0) return 'error';
    return "";
  }

  onChangeService(event) {
    this.setState({
      form_service: event.target.value
    })
  }

  render() {

    return (
      <Loader show={this.state.load} message={<div className="loader"></div>}
        backgroundStyle={{ backgroundColor: 'none' }}
        foregroundStyle={{ color: 'white', backgroundColor: 'rgb(255,255,255,0.7)' }}>
        <div className="user-detail-page">

          {this.state.createUserMessage && this.state.createUserMessage != '' ?
            <Alert bsStyle="warning">
              {this.renderMessage(this.state.createUserMessage)}
            </Alert>
            : null}

          {this.state.messageAll && this.state.messageAll != '' ?
            <Alert bsStyle={!this.state.messageAllStatus || this.state.messageAllStatus == '' ? 'warning' : this.state.messageAllStatus}>
              {this.renderMessage(this.state.messageAll)}
            </Alert>
            : null}

          <Grid className="grid-profile-top">
            <Row>
              <Col xs={3} md={3}>
                {
                  this.state.urlProfilePick != "" ?
                    <div className="image_container_profile">
                      <Image className="img_profile" src={this.state.urlProfilePick} />
                    </div>

                    :
                    <Image className="img-profile" src={placeholderUser} circle />
                }

              </Col>
              <Col xs={5} md={5} className="text-left">
                <h1>{
                  this.state.aluno ?
                    <If test={true}>
                      {this.state.aluno.data.last_name ?
                        <If test={true}>
                          {this.state.aluno.data.name} {this.state.aluno.data.last_name}
                        </If>
                        :
                        this.state.aluno.data.name
                      }
                    </If> : ""
                }</h1>
                <p className="email-label"><strong>{this.state.aluno ? this.state.aluno.data.email : ""}</strong></p>
                <p className="email-label"><strong>{this.state.aluno && this.state.aluno.data.phone ? this.state.aluno.data.phone : ""}</strong></p>
                <p className="email-label">{this.state.aluno && this.state.aluno.data.born_date ? this.state.aluno.data.born_date : ""}</p>
                <p>{this.state.aluno ?
                  (this.getGenderName(this.state.aluno.data.gender) + ", " + this.getAge(this.state.aluno.data.born_date) + " anos")
                  : ""}</p>
                {/* <p className="primaryFontColor bold">{this.state.aluno ? this.state.aluno.data.email : ""}</p> */}
                <div className="flex-column">
                  <Button className="primaryFontColor bold" variant="light" onClick={() => this.openModalChangeService()}>{(this.state.aluno && this.state.aluno.data.service == "personal") ? "ALUNO PERSONAL" : "CONSULTORIA ESPORTIVA"}&nbsp;&nbsp;<Glyphicon className="black" glyph="pencil" /></Button>
                  <Button className="button-contract-date" bsStyle={`${(
                    this.state.aluno
                    &&
                    (
                      !this.state.aluno.data.contract_date
                      ||
                      (difDates(new Date, formatJsDateToPt(this.state.aluno.data.contract_date)) == null || difDates(new Date, formatJsDateToPt(this.state.aluno.data.contract_date)) <= 0)
                    )
                  )
                    ?
                    'danger'
                    :
                    (
                      this.state.aluno && this.state.aluno.data && this.state.aluno.data.contract_date && difDates(new Date(), formatJsDateToPt(this.state.aluno.data.contract_date)) > 10
                        ?
                        'success'
                        :
                        'warning'
                    )
                    }`} onClick={() => this.handleOpenContractDateModal()}>Contrato: {(this.state.aluno && this.state.aluno.data && this.state.aluno.data.contract_date) ? formatJsDateToPt(this.state.aluno.data.contract_date) : "Não informado"}</Button>
                </div>
                {/* <p className="primaryFontColor bold"></p> */}

              </Col>

              {/* Caso esteja no estado de espera não apresenta-se o botão de ativação e inativação */}
              {this.state.aluno && this.state.aluno.data.status != "WAIT_ACCEPT" ?
                <Col xs={4} md={4} className="buttons-detail-user">

                  {this.state.aluno && this.state.aluno.data.status == "ACTIVE" ?

                    <Button bsStyle="sencodary" onClick={() => this.inactiveUser()}>Inativar aluno</Button>
                    :
                    <div className="active-remove-user">
                      <Button className="active-user-btn" bsStyle="success" onClick={() => this.doActiveUser()}>Ativar aluno</Button>
                      <Button variant="dark" onClick={() => this.handleShowConfirmDeleteUser()}>Remover aluno</Button>
                    </div>

                  }
                </Col>
                :
                null
              }
            </Row>
          </Grid>

          <If test={this.state.aluno && this.state.aluno.data.status == "WAIT_ACCEPT"}>
            <Grid>
              <Row>
                <Col>
                  <Jumbotron>
                    <h1>Aguardando aceitação</h1>
                    <p>
                      Ao aceitar o aluno ele poderá entrar no sistema com o <strong>Email</strong> e a <strong>data de nascimento</strong> como senha! O aluno então terá acesso ao formulário de ANAMNESE e também ao contrato.
                    </p>
                    <p className="btns-acept-remove-user">
                      <Button className="btn-acept-user" bsStyle="primary" onClick={() => this.saveUser()}>Aceitar aluno</Button>
                      <Button bsStyle="danger" onClick={() => this.removeRequisitionUser()}>Remover aluno</Button>
                    </p>
                  </Jumbotron>;
                </Col>
              </Row>
            </Grid>
          </If>

          <If test={this.state.aluno && this.state.aluno.data.status == "ACTIVE"}>

            <Tabs defaultActiveKey={1} className="profile-tabs">
              <Tab eventKey={1} title="Treino">

                <If test={this.state.aluno && this.state.aluno.data && (!this.state.aluno.data.training || this.state.aluno.data.training == '')}>
                  <h1>Treino</h1>
                  <p>Selecione um treino para este aluno</p>
                  <p>
                    <Button onClick={() => this.openModalSelectTraining()} bsStyle="primary">Selecionar treino</Button>
                  </p>
                </If>
                <If test={this.state.aluno && this.state.aluno.data && this.state.aluno.data.training}>

                  {/* <Loader show={this.state.load_training_tab} message={<div className="loader"></div>}
                    backgroundStyle={{ backgroundColor: 'none' }}
                    foregroundStyle={{ color: 'white', backgroundColor: 'rgb(255,255,255,0.7)' }}> */}

                  {this.state.messageTabTraining && this.state.messageTabTraining != '' ?
                    <Alert bsStyle={'warning'}>
                      {this.renderMessage(this.state.messageTabTraining)}
                    </Alert>
                    : null}

                  <If test={this.state.training_to_look}>
                    {/* Pequeno workaround para atualizar componente */}
                    <If test={this.state.updateComponenent}>
                      <MountTraining trainingToLook={this.state.training_to_look} changeUserTraining={() => this.openModalSelectTraining()} changeTimeTraining={() => this.handleOpenTimeTrainingModal()} />
                    </If>
                    <If test={!this.state.updateComponenent}>
                      <MountTraining trainingToLook={this.state.training_to_look} changeUserTraining={() => this.openModalSelectTraining()} changeTimeTraining={() => this.handleOpenTimeTrainingModal()} />
                    </If>
                  </If>

                  {/* </Loader> */}

                </If>

              </Tab>
              <Tab eventKey={2} title="Avaliações">


                <If test={this.state.aluno && this.state.aluno.data.status == "ACTIVE"}>
                  <Grid>
                    <Row className="infos-body-profile">
                      <Col md={4} className="input-info-body" onClick={() => this.handleOpenWeightModal()}>
                        {(this.state.aluno
                          && this.state.aluno.data.infos_body
                          && this.state.aluno.data.infos_body.weight) ?
                          <h1 className="label-info-body">{this.state.aluno.data.infos_body.weight}</h1>
                          :
                          <h1 className="label-info-body"> - </h1>
                        }
                        <p className="primaryFontColor bold">PESO</p>
                      </Col>
                      <Col md={4} className="input-info-body" onClick={() => this.handleOpenHeightModal()}>
                        {(this.state.aluno
                          && this.state.aluno.data.infos_body
                          && this.state.aluno.data.infos_body.height) ?
                          <h1 className="label-info-body">{this.state.aluno.data.infos_body.height}</h1>
                          :
                          <h1 className="label-info-body"> - </h1>
                        }
                        <p className="primaryFontColor bold">ALTURA</p>
                      </Col>
                      <Col md={4}>
                        {this.state.aluno
                          && this.state.aluno.data.infos_body
                          && this.state.aluno.data.infos_body.weight && this.state.aluno.data.infos_body.height ?
                          <h1 className="label-info-body">{this.getImc()}</h1>
                          :
                          <h1 className="label-info-body"> - </h1>
                        }
                        <p className="primaryFontColor bold">IMC</p>
                      </Col>
                    </Row>
                    <Row className="files-body-profile">
                      <Col md={12}>
                        <Panel className="file-body">
                          <h1>ALONGAMENTOS</h1>
                          <div className="action-file" onClick={() => this.uploadFile(1)}>
                            <Image src={editImg} responsive />
                            <p className="primaryFontColor">Editar</p>
                            <FormControl
                              ref="inputNode1"
                              className="input-file-body"
                              type="file"
                              onChange={(e) => this.handleFileUpload1(e)}
                            />

                          </div>

                        </Panel>
                      </Col>
                      <Col md={12}>
                        <Panel className="file-body">
                          <h1>AVALIAÇÕES FÍSICAS</h1>
                          <div className="action-file" onClick={() => this.uploadFile(2)}>
                            <Image src={editImg} responsive />
                            <p className="primaryFontColor">Editar</p>
                            <FormControl
                              ref="inputNode2"
                              className="input-file-body"
                              type="file"
                              onChange={(e) => this.handleFileUpload2(e)}
                            />
                          </div>
                        </Panel>
                      </Col>
                      <Col md={12}>
                        <Panel className="file-body">
                          <h1>EBOOK</h1>
                          <div className="action-file" onClick={() => this.uploadFile(3)}>
                            <Image src={editImg} responsive />
                            <p className="primaryFontColor">Editar</p>
                            <FormControl
                              ref="inputNode3"
                              className="input-file-body"
                              type="file"
                              onChange={(e) => this.handleFileUpload3(e)}
                            />
                          </div>
                        </Panel>
                      </Col>
                      <Col md={12}>
                        <Panel className="file-body">
                          <h1>LEGENDAS</h1>
                          <div className="action-file" onClick={() => this.uploadFile(4)}>
                            <Image src={editImg} responsive />
                            <p className="primaryFontColor">Editar</p>
                            <FormControl
                              ref="inputNode4"
                              className="input-file-body"
                              type="file"
                              onChange={(e) => this.handleFileUpload4(e)}
                            />
                          </div>
                        </Panel>
                      </Col>
                      <Col md={12}>
                        <Panel className="file-body">
                          <h1>PLANO ALIMENTAR</h1>
                          <div className="action-file" onClick={() => this.uploadFile(5)}>
                            <Image src={editImg} responsive />
                            <p className="primaryFontColor">Editar</p>
                            <FormControl
                              ref="inputNode5"
                              className="input-file-body"
                              type="file"
                              onChange={(e) => this.handleFileUpload5(e)}
                            />
                          </div>
                        </Panel>
                      </Col>
                    </Row>
                  </Grid>
                </If>


              </Tab>
              <Tab eventKey={3} title="Anamnese">


                <If test={this.state.updateComponenentAnamnese}>
                  <Anamnese user={this.state.aluno} handleSaveAnamnese={(anamnese) => this.handleSaveAnamnese(anamnese)} />
                </If>
                <If test={!this.state.updateComponenentAnamnese}>
                  <Anamnese user={this.state.aluno} handleSaveAnamnese={(anamnese) => this.handleSaveAnamnese(anamnese)} />
                </If>

              </Tab>
              {/* <Tab eventKey={3} title="Contrato">


                <h1>Contrato</h1>
                <p>
                  Insira um contrato para ser avaliado pelo aluno.
                    </p>
                <p>
                  <Button bsStyle="success">Anexar contrato</Button>
                </p>


              </Tab> */}

            </Tabs>
          </If>
          {/*
          <If test={this.state.aluno && this.state.aluno.data.status == "INATIVE"}>
            <Grid>
              <Row>
                <Col xs={12} md={12}>
                  <Jumbotron>
                    <h1>Contrato</h1>
                    <p>
                      Insira um contrato para ser avaliado pelo aluno.
                    </p>
                    <p>
                      <Button bsStyle="success">Anexar contrato</Button>
                    </p>
                  </Jumbotron>
                </Col>
                <Col xs={12} md={12}>
                  <Jumbotron>
                    <h1>Anamnese</h1>
                    <p>
                      Acompanhe o formulário de informações detalhadas do aluno.
                    </p>
                    <p>
                      <Button bsStyle="primary">Detalhes</Button>
                    </p>
                  </Jumbotron>;
                </Col>
              </Row>
            </Grid>

          </If> */}

          <Modal show={this.state.showModalTimeTraining}
            bsSize="small">

            <Loader show={this.state.loadModalTimeTraining} message={<div className="loader"></div>}
              backgroundStyle={{ backgroundColor: 'none' }}
              foregroundStyle={{ color: 'white', backgroundColor: 'rgb(255,255,255,0.7)' }}>

              <Modal.Header>
                <Modal.Title>
                  <p className="bold label-modal-infos-body">Alterar vencimento</p>
                </Modal.Title>
              </Modal.Header>

              <Modal.Body className="in-modal body-input-info-body">
                <div>
                  <FormGroup controlId="formControlsBornDate"
                    className="input-group-time-training"
                    validationState={((this.getValidationStateTimeTrainingDate()).split("/"))[0]}>
                    <FormControl
                      className="input-time-training"
                      name="form_time_training"
                      type="text"
                      value={this.state.form_time_training}
                      placeholder="DD/MM/YYYY"
                      onChange={(event) => this.onInputDateMaskChange(event.target)} />
                    <FormControl.Feedback className="feedback-input-time-training" />
                  </FormGroup>

                  {((this.getValidationStateTimeTrainingDate()).split("/"))[0] == "error" ?
                    <p className="feedback-input-time-training">{((this.getValidationStateTimeTrainingDate()).split("/"))[1]}</p>
                    : null}
                </div>
              </Modal.Body>

              <Modal.Footer>

                <Button onClick={() => this.handleCloseTimeTrainingModal()}>Fechar</Button>
                <If test={((this.getValidationStateTimeTrainingDate()).split("/"))[0] != "success"}>
                  <Button bsStyle="primary" disabled>Salvar</Button>
                </If>
                <If test={((this.getValidationStateTimeTrainingDate()).split("/"))[0] == "success"}>
                  <Button bsStyle="primary" onClick={() => this.updateTimeTraining()}>Salvar</Button>
                </If>

              </Modal.Footer>
            </Loader>
          </Modal>

          <Modal show={this.state.showModalContractDate}
            bsSize="small">

            <Loader show={this.state.loadModalContractDate} message={<div className="loader"></div>}
              backgroundStyle={{ backgroundColor: 'none' }}
              foregroundStyle={{ color: 'white', backgroundColor: 'rgb(255,255,255,0.7)' }}>

              <Modal.Header>
                <Modal.Title>
                  <p className="bold label-modal-infos-body">Alterar data contrato</p>
                </Modal.Title>
              </Modal.Header>

              <Modal.Body className="in-modal body-input-info-body">
                <div>
                  <FormGroup controlId="formControlsBornDate"
                    className="input-group-time-training"
                    validationState={((this.getValidationStateContractDate()).split("/"))[0]}>
                    <FormControl
                      className="input-time-training"
                      name="form_contract_date"
                      type="text"
                      value={this.state.form_contract_date}
                      placeholder="DD/MM/YYYY"
                      onChange={(event) => this.onInputDateMaskChange(event.target)} />
                    <FormControl.Feedback className="feedback-input-contract-date" />
                  </FormGroup>

                  {((this.getValidationStateContractDate()).split("/"))[0] == "error" ?
                    <p className="feedback-input-contract-date">{((this.getValidationStateContractDate()).split("/"))[1]}</p>
                    : null}
                </div>
              </Modal.Body>

              <Modal.Footer>

                <Button onClick={() => this.handleCloseContractDateModal()}>Fechar</Button>
                <If test={((this.getValidationStateContractDate()).split("/"))[0] != "success"}>
                  <Button bsStyle="primary" disabled>Salvar</Button>
                </If>
                <If test={((this.getValidationStateContractDate()).split("/"))[0] == "success"}>
                  <Button bsStyle="primary" onClick={() => this.updateContractDate()}>Salvar</Button>
                </If>

              </Modal.Footer>
            </Loader>
          </Modal>

          <Modal show={this.state.showModalWeight}
            bsSize="small">

            <Loader show={this.state.loadModalWeight} message={<div className="loader"></div>}
              backgroundStyle={{ backgroundColor: 'none' }}
              foregroundStyle={{ color: 'white', backgroundColor: 'rgb(255,255,255,0.7)' }}>

              <Modal.Header>
                <Modal.Title>
                  <p className="label-modal-infos-body">Informe o peso</p>
                </Modal.Title>
              </Modal.Header>

              <Modal.Body className="in-modal body-input-info-body">
                <div className="row-flex">
                  <FormControl
                    className="edit-input-info-body"
                    name="form_weight"
                    type="text"
                    value={this.state.form_weight}
                    placeholder="Peso"
                    onChange={(event) => this.onInputWeightChange(event.target)} />

                  <p className="no-m-bottom">KG</p>
                </div>
              </Modal.Body>

              <Modal.Footer>

                <Button onClick={() => this.handleCloseWeightModal()}>Fechar</Button>
                <If test={!this.state.form_weight || this.state.form_weight == ''}>
                  <Button bsStyle="primary" disabled>Salvar</Button>
                </If>
                <If test={this.state.form_weight && this.state.form_weight != ''}>
                  <Button bsStyle="primary" onClick={() => this.saveWeight()}>Salvar</Button>
                </If>

              </Modal.Footer>
            </Loader>
          </Modal>

          <Modal show={this.state.showModalHeight}
            bsSize="small">

            <Loader show={this.state.loadModalHeight} message={<div className="loader"></div>}
              backgroundStyle={{ backgroundColor: 'none' }}
              foregroundStyle={{ color: 'white', backgroundColor: 'rgb(255,255,255,0.7)' }}>

              <Modal.Header>
                <Modal.Title>
                  <p className="label-modal-infos-body">Informe a altura</p>
                </Modal.Title>
              </Modal.Header>

              <Modal.Body className="in-modal body-input-info-body">
                <div className="row-flex">
                  <FormControl
                    className="edit-input-info-body"
                    name="form_height"
                    type="text"
                    value={this.state.form_height}
                    placeholder="Altura"
                    onChange={(event) => this.onInputHeightChange(event.target)} />
                  <p className="no-m-bottom">m</p>
                </div>
              </Modal.Body>

              <Modal.Footer>

                <Button onClick={() => this.handleCloseHeightModal()}>Fechar</Button>
                <If test={!this.state.form_height || this.state.form_height == ''}>
                  <Button bsStyle="primary" disabled>Salvar</Button>
                </If>
                <If test={this.state.form_height && this.state.form_height != ''}>
                  <Button bsStyle="primary" onClick={() => this.saveHeight()}>Salvar</Button>
                </If>

              </Modal.Footer>
            </Loader>
          </Modal>

          <Modal show={this.state.showModalSelectTraining}
            dialogClassName="no-padding all-exercises-modal">

            <Loader show={this.state.loadSelectTrainingModal} message={<div className="loader"></div>}
              backgroundStyle={{ backgroundColor: 'none' }}
              foregroundStyle={{ color: 'white', backgroundColor: 'rgb(255,255,255,0.7)' }}>

              <Modal.Header>
                <Modal.Title>
                  <If test={!this.state.select_training_detailed}>
                    <Grid>
                      <Row className="flex-row">
                        <Col xs={6} md={6} className="no-p-left no-p-right text-left">
                          <p className="no-m-bottom">Selecione o treino</p>
                        </Col>
                        <Col xs={6} md={6} className="no-p-left no-p-right text-left">
                          <FormControl
                            name="search_table_all_trainings"
                            type="text"
                            value={this.state.search_table_all_trainings}
                            placeholder="Pesquisar treino"
                            onChange={(event) => this.onInputChange(event.target)} />
                        </Col>
                      </Row>
                    </Grid>
                  </If>

                  <If test={this.state.select_training_detailed}>
                    <div className="flex-back-modal">
                      <Glyphicon glyph="chevron-left" onClick={() => this.backDetailTrainingModal()} /><p className="no-m-bottom">Detalhe</p>
                    </div>
                  </If>


                </Modal.Title>
              </Modal.Header>

              <Modal.Body className={`in-modal ${this.state.select_training_detailed ? 'padding-extra-20' : ''} `}>

                <If test={!this.state.select_training_detailed}>
                  <TableTrainings search={this.state.search_table_all_trainings}
                    handleDetailTrainingModal={(training) => this.handleDetailTraining(training)}
                    handleSelectTrainingModal={(training) => this.handleSelectTrainingModal(training)}
                    selectedTrainingModal={this.state.selected_training_modal} />
                </If>
                <If test={this.state.select_training_detailed} >
                  <MountTraining trainingToDetailModal={this.state.select_training_detailed} />
                </If>

              </Modal.Body>

              <Modal.Footer>
                <If test={!this.state.select_training_detailed}>
                  <Button onClick={() => this.handleCloseTrainingsModal()}>Fechar</Button>
                  <If test={!this.state.selected_training_modal}>
                    <Button bsStyle="primary" disabled>Selecionar</Button>
                  </If>
                  <If test={this.state.selected_training_modal}>
                    <Button bsStyle="primary" onClick={() => this.selectTrainingToUser()}>Selecionar</Button>
                  </If>
                </If>
                <If test={this.state.select_training_detailed}>
                  <Button onClick={() => this.backDetailTrainingModal()}>Voltar</Button>
                </If>
              </Modal.Footer>
            </Loader>
          </Modal>


          <Modal show={this.state.showModalPdfsAvaliations}
            dialogClassName="no-padding pdfs-modal">

            <Loader show={this.state.loadPdfsAvaliations} message={<div><div className="loader"></div><p className="loader-text">Aguarde...</p></div>}
              backgroundStyle={{ backgroundColor: 'none' }}
              foregroundStyle={{ color: 'white', backgroundColor: 'rgb(255,255,255,0.7)' }}>

              <Modal.Header>
                <Modal.Title>
                  <p className="no-m-bottom">{this.state.title_type_avaliations}</p>
                </Modal.Title>
              </Modal.Header>

              <Modal.Body>

                <If test={(this.state.aluno && !this.state.aluno.data.evaluations)
                  || (
                    this.state.aluno
                    && this.state.aluno.data.evaluations
                    && !this.state.aluno.data.evaluations[this.state.type_avaliation]
                  )
                  || (
                    this.state.aluno
                    && this.state.aluno.data.evaluations
                    && this.state.aluno.data.evaluations[this.state.type_avaliation] != null
                    && this.state.aluno.data.evaluations[this.state.type_avaliation].length == 0
                  )}>
                  <p>Nenhuma avaliação disponível</p>
                </If>

                {(this.state.aluno
                  && this.state.type_avaliation != 0
                  && this.state.aluno.data.evaluations
                  && this.state.aluno.data.evaluations[this.state.type_avaliation] != undefined
                  && this.state.aluno.data.evaluations[this.state.type_avaliation].length > 0) ?
                  <ListPdfsAvaliations
                    startLoader={() => this.setState({
                      loadPdfsAvaliations: true,
                    })}
                    stopLoader={() => this.setState({
                      loadPdfsAvaliations: false,
                    })}
                    closeModal={(message) => this.closeAndMessageEvaluationsModal(message)}
                    aluno={this.state.aluno}
                    typeEvaluation={this.state.type_avaliation} />
                  :
                  null
                }

              </Modal.Body>

              <Modal.Footer>
                <Button bsStyle="primary" onClick={() => this.selectPdfToUpload(this.state.type_avaliation)}>Adicionar</Button>
                <Button onClick={() => this.handleCloseModalPdfs()}>Fechar</Button>
              </Modal.Footer>
            </Loader>
          </Modal>

          <Modal show={this.state.showDialogConfirmDeleteUser}
            bsSize="small">

            <Modal.Header>
              <Modal.Title>Remover usuário</Modal.Title>
            </Modal.Header>

            <Modal.Body className="text-center">
              <h4>Deseja realmente remover o aluno?</h4>
              <h2><b>{this.state.aluno ? this.state.aluno.data.name : null}</b></h2>

            </Modal.Body>

            <Modal.Footer>
              <Button onClick={() => this.handleCloseConfirmDeleteUser()}>Fechar</Button>
              <Button bsStyle="danger" onClick={() => this.deleteUser(this.state.aluno)}>Excluir</Button>

            </Modal.Footer>

          </Modal>

          <Modal show={this.state.showDialogChangeService}
            bsSize="small">

            <Loader show={this.state.loadModalService} message={<div><div className="loader"></div><p className="loader-text">Atualizando...</p></div>}
              backgroundStyle={{ backgroundColor: 'none' }}
              foregroundStyle={{ color: 'white', backgroundColor: 'rgb(255,255,255,0.7)' }}>

              <Modal.Header>
                <Modal.Title>Alterar Serviço</Modal.Title>
              </Modal.Header>

              <Modal.Body className="text-center">

                <FormGroup controlId="formControlsSelect">
                  <FormControl componentClass="select" placeholder="Selecione" onChange={(event) => this.onChangeService(event)}>
                    <If test={this.state.form_service == "consult"}>
                      <option selected value="consult">Consultoria esportiva</option>
                      <option value="personal">Personal trainer</option>
                    </If>
                    <If test={this.state.form_service == "personal"}>
                      <option value="consult">Consultoria esportiva</option>
                      <option selected value="personal">Personal trainer</option>
                    </If>
                  </FormControl>
                </FormGroup>

              </Modal.Body>

              <Modal.Footer>
                <Button onClick={() => this.handleCloseChangeService()}>Fechar</Button>
                <Button bsStyle="primary" onClick={() => this.updateService()}>Atualizar</Button>

              </Modal.Footer>
            </Loader>

          </Modal>

        </div>
      </Loader >
    );
  }
}

export default AlunoDetail;



// WEBPACK FOOTER //
// src/components/alunos/user-detail.js